import { makeCompositeId } from '@cbridge-utils/formatters';
import { INode } from '@cbridge-packages/node';
import { IServer } from '@cbridge-packages/server';
import { ISymbolClient, IServerSymbolIdentifier, INodeSymbolIdentifier } from '../symbolClient.interface';

export const makeServerSymbolCompositeId = (
  serverId: IServer['serverId'], name: ISymbolClient['clientSymbolName'],
)=> makeCompositeId([serverId, name]);

export const makeNodeSymbolCompositeId = (
  nodeId: INode['nodeId'], name: ISymbolClient['clientSymbolName'],
) => makeCompositeId([nodeId, name]);

export const makeClientSymbolCompositeId = (params: IServerSymbolIdentifier | INodeSymbolIdentifier) => {
  if ('serverId' in params) {
    return makeServerSymbolCompositeId(params.serverId, params.name);
  } else {
    return makeNodeSymbolCompositeId(params.nodeId, params.name);
  }
};
